import api from '@/utils/api'

export default {
    createMembership(data) {
        return api.post(`memberships`, data)
    },
    getMembership(membershipId) {
        return api.get(`memberships/${membershipId}`)
    },
    getMemberships(params) {
        return api.get(`memberships`, { params })
    },
    updateMembership(membershipId, data) {
        return api.put(`memberships/${membershipId}`, data)
    },
    getFilteredMemberships(filters, page, size) {
        const params = { ...filters, page, size }
        return api.get(`memberships`, { params })
    }
}
